// Compiler result to JSON file
import { createComponent } from 'js/declViewModelService';
import { registerDynImportEntry } from 'js/moduleLoader';
import AwParseService from 'js/awParseService';
import AwFilterService from 'js/awFilterService';
import { getField } from 'js/utils';
import { Fragment } from 'react';
let filterSer = AwFilterService.instance;

/*
render function
*/
import { awFileUploadLabelFunction } from 'js/DesAwFileDirUploadLabel';

/*
ctx imports
*/

const ctxImportObj = {};

/*
dynamic import
 */
registerDynImportEntry('js/DesAwFileDirUploadLabel', () => import('js/DesAwFileDirUploadLabel'));
;

/*
view model
 */
const declViewModelJson = {
  "schemaVersion": "1.0.0",
  "imports": [],
  "actions": {
    "render": {
      "method": "awFileUploadLabelFunction",
      "deps": "js/DesAwFileDirUploadLabel"
    }
  },
  "data": {},
  "conditions": {},
  "onEvent": [],
  "lifecycleHooks": {
    "render": "render"
  },
  "i18n": {
    "removeFileBtnTooltip": ["UIElementsMessages"],
    "MB": ["UIElementsMessages"]
  },
  "props": {
    "item": {
      "type": "object"
    },
    "remove-file-handler": {
      "type": "action"
    },
    "remove-tooltip": {
      "type": "string"
    }
  },
  "_viewModelId": "DesAwFileDirUploadLabel",
  "_uniqueViewModelId": "DesAwFileDirUploadLabel",
  "ctx": {}
};

/*
define component
*/
const Component = createComponent(declViewModelJson, awFileUploadLabelFunction, undefined, ctxImportObj);
export default Component;